import _ from 'lodash'

export class ChangeTracker<TValue> {
  private lastKnownState: Record<string, TValue>

  constructor() {
    this.lastKnownState = {}
  }

  public trackChange(key: string, value: TValue) {
    this.lastKnownState[key] = value
  }

  public isChangedSinceTracked(key: string, value: TValue) {
    return !_.isEqual(_.get(this.lastKnownState, key), value)
  }
}
